/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/upperCaseFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoHeightWidthMatch implements angular.IDirective {
        private window: angular.IWindowService;
        restrict = "A";


        constructor($window: ng.IWindowService) {
            this.window = $window;
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var elementId = attrs['elementId'];
            scope.elementHeight = null;
            function setElementHeight() {
                scope.elementHeight = angular.element(elementId).css('width');
                scope.$apply();
            }
            window.setTimeout(function () {
                setElementHeight();

            }, 100)
                
            angular.element(window).bind('orientationchange', function () {

                window.setTimeout(function () {
                    setElementHeight();
                }, 1000);
               
            }); 
            angular.element(window).on('resize', function () {
                setElementHeight();

            });
            
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($window) => {
                return new MeevoHeightWidthMatch($window);
            };

            directive.$inject = ["$window"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoHeightWidthMatch", MeevoHeightWidthMatch.factory());
}